import RegularMap from './RegularMap';

export default RegularMap;
